import { useState, useCallback } from 'react'

import axios from 'axios'
import { sleep } from '../utils/utils';
import { LAMPORTS_PER_SOL } from '@solana/web3.js';

// WASM 모듈 import
import init from '../wasm/rust_wassm_fetch';
import {
	get_server_tx_history,
	reset_server_tx_history
} from '../wasm/rust_wassm_fetch';
// WASM 초기화 함수 import
import { initializeWasm } from '../wasm/wasmutils';

const useQwalletServer = () => {
	
	/**
	 * DB TX 데이터 초기화 요청
	 * @param walletAddress
	 * @param network
	 * @param tid
	 * @returns
	 */
	const resetServerTxHistory = async (walletAddress: string, network: string, tid: string): Promise<boolean> => {
		try {
			// WASM 초기화 보장
			await initializeWasm();

			const result = await reset_server_tx_history(
				process.env.REACT_APP_QWALLET_SERVER_URL!,
				walletAddress,
				network,
				tid
			);
			
			console.log(`resetServerTxHistory result`, result)

			const response = JSON.parse(result)
			console.log(`JSON.parse response`, response)

			if(true === response.result) {	
				console.log(`1 resetServerTxHistory DB TX 초기화 성공`)
			}

			return true;
		} catch (error) {
			console.error('Error resetServerTxHistory', error);
			return false;
		}
	}

	/**
	 * 게임 airdrop 주소 업데이트
	 * @param walletAddress 
	 * @param tid 
	 * @returns 
	 */
	const updateAirdropWalletAddress = async (walletAddress: string, tid: string): Promise<any | null> => {
		// 파라미터 유효성 검사
		if (!walletAddress || typeof walletAddress !== 'string' || walletAddress.trim() === '') {
			console.error('유효하지 않은 지갑 주소입니다.');
			return false;
		}

		if (!tid || typeof tid !== 'string' || tid.trim() === '') {
			console.error('유효하지 않은 텔레그램 ID입니다.');
			return false;
		}

		if (!process.env.REACT_APP_AIRDROP_UPDATE_URL || typeof process.env.REACT_APP_AIRDROP_UPDATE_URL !== 'string' || process.env.REACT_APP_AIRDROP_UPDATE_URL.trim() === '') {
			console.warn('에어드롭 지갑주소 업데이트 URL이 없습니다');
			return true;
		}

		try {
			const response = await axios.put(`${process.env.REACT_APP_AIRDROP_UPDATE_URL}`, {
				id: tid,
				address: walletAddress,
			});

			console.log(`서버 응답 데이터:`, response);

			if (response.status !== 200) {
				console.error('서버 응답이 실패했습니다:', response.status);
				return false;
			}

			if (!response.data || (response.data.code !== 1000 && response.data.code !== -1000)) {
				console.error('서버 응답 데이터가 올바르지 않습니다:', response.data);
				return false;
			}
			
			console.log(`서버에서 받은 리턴 데이터:`, response.data);
			
			return true;

		} catch (error) {
			console.error('서버 airdrop 주소 업데이트 중 오류 발생 :', error);
			return false;
		}
	}

	return {
		resetServerTxHistory,
		updateAirdropWalletAddress
	}
}

export default useQwalletServer
